export default __webpack_public_path__ + "static/LP-imageGrid-2e72ef51598b37e147b1d79f6875e01c.mp4";